<div class="booking-banner">
    <a (click)="setGoogleAnalytic()" href="https://www.booking.com/index.html?aid=7947415" target="_blank">
        <img class="booking-banner__img"
             src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/hotels/banner/booking-banner_3.png?_a=ATFGlAA0"
             alt="banner">
        <div class="booking-banner__texts">
            <p class="b-text b-text--w-bg">Book your accommodations on <span><img
                    src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/booking.png?_a=ATFGlAA0"
                    width="150" height="24" alt="booking logo"/></span> through our site,
            </p>
            <p class="b-text b-text--w-bg">and enjoy the benefits of Booking.com <i>Genius</i> loyalty
                program</p>
            <p class="b-text b-text--w-bg">and RoutePerfect travel perk</p>
        </div>
        <p class="visit-text visit-text--absolute">visit <span><img
                src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/booking.png?_a=ATFGlAA0"
                width="136" height="22" alt="booking logo"/></span>
        </p>
    </a>
</div>
